export default {
  main: {
    title: '版本驗證',
    language: '繁體中文',
    intro:
      '版本驗證通過比對不同版本之間的MD5或SHA256雜湊值來進行。請確保透過官方渠道下載TokenPocket錢包，以避免被欺騙。關於如何獲取某個版本的MD5或SHA256雜湊值的說明，請參考',
    tutorial: '教程 >',
    system: '操作系統',
    android: 'Android',
    ios: 'iOS',
    version: '版本',
    allVersion: '全部',
    appChannel: '應用渠道',
    developer: '開發者',
    allChannel: '全部',
    md5: 'MD5',
    sha256: 'SHA256',
    log: '版本日誌',
    check: '詳情',
    versionLog: '版本日誌',
    confirm: '確認',
    aboutIOS: '關於iOS版本',
    IOSDesc:
      '對於iOS版本，我們僅在App Store上提供我們的應用。只有透過App Store下載的應用程序才能正確安裝。因此，在使用蘋果設備時，請確保將App Store驗證為唯一的下載渠道。',
    IOSDesc_2:
      '在2022年10月8日之前從App Store下載的版本的開發者是TOKENPOCKET FOUNDATION LTD，這是TokenPocket開發的早期版本。這是一個合法的錢包，可以正常使用，但更新服務將暫時停止。',
    aboutAndroid: '關於安卓版本',
    androidDesc: '當前TokenPocket提供安卓下載的渠道包括：官網、谷歌商店、三星應用商店、華為應用商店、OPPO應用商店、Vivo應用商店。由於個別應用商店在下載過程中無法獲取到apk安裝包，因此無法進行MD5或SHA256計算校驗！所以，請您在下載的時候，務必核對清楚開發商信息，參照下方',
    IOSAppName: '應用名稱：',
    TPWallet: 'TP錢包',
    AppIcon: '應用圖示：',
    AppDeveloper: '開發者：',
    downloadLink: '下載連結：',
    copied: '已複製！',
    versionVerification: '版本校验',
  },
  follow: {
    title: '關注我們',
    desc1: 'TokenPocket 客服不會私聊您！',
    desc2:
      '請注意，您即將進入TokenPocket社區，您進入社區可能會有人假冒TokenPocket的工作人員私聊您，請您務必警惕，所有私聊您的都可能是騙子！ TokenPocket工作人員不會主動跟您私信！',
    desc3: '知道了，繼續前往',
  },
  COMMON: {
    LAYOUT: {
      features: '功能',
      products: '產品',
      buyCryptoFooter: '購買數字資產',
      mobileWallet: '手機錢包',
      mobileWalletDesc: '您的移動端數字資產錢包，支持iOS和Android',
      hardwareWallet: '硬體錢包',
      hardwareWalletDesc: '擁有KeyPal，讓您的資產更安全',
      extensionWallet: '插件錢包',
      extensionWalletDesc: '您電腦上更好用的錢包',
      desktop: '桌面端錢包',
      fiveDegrees: '5Degrees',
      versionVerification: '版本校驗',
      versionVerificationDesc: '驗證你的錢包是否為正版',
      approvalDetector: '授權檢測',
      approvalDetectorDesc: '查看和取消授權您已經授權的代幣',
      tokenSecurity: '代幣安全檢測',
      tokenSecurityDesc: '通過合約地址檢查代幣是否安全',
      keyGenerator: '私鑰生成器',
      keyGeneratorDesc: '在多個網絡上生成公鑰和私鑰',
      tokenProfile: '代幣資訊',
      tokenProfileDesc: '了解代幣的全方位資訊',
      tokenClaim: '領取空投',
      tokenClaimDesc: '獲取您的空投',
      easyInscription: '銘文助手',
      easyInscriptionDesc: '安全的銘文鑄造工具',
      nostrAssetsBatchSender: 'Nostr批量轉帳',
      nostrAssetsBatchSenderDesc: 'Nostr資產的批量發送工具',
      BATCH_SENDER: '批量轉帳',
      BATCH_SENDER_DESC: '一次性向多個接收者批量發送代幣',
  
      trade: '交易',
      swap: '閃兌',
      swapDesc: '用最優價格交易',
      bridge: '跨鏈橋',
      bridgeDesc: 'Ensuring seamless asset liquidity.',
      buyCrypto: '購買代幣',
      buyCryptoDesc: '用信用卡購買數字資產',
      market: '市場',
      marketDesc: '實時洞察，發現熱門代幣',
  
      information: '信息',
      blockchainGuide: '區塊鏈小白書',
      tronWallet: '波場小白書',
      iostWallet: 'IOST小白書',
      tpMan: 'TP俠',
  
      developers: '開發者',
      github: 'Github (TP-Lab)',
      devCenter: '開發者中心',
      developersDesc: 'TokenPocket的開發者文檔',
      subToken: '提交代幣',
      subTokenDesc: '提交您的數字資產',
      subDApp: '提交DApp',
      subDAppDesc: '提交您的DApp，我們將在審核後展示它',
      subNFT: '提交NFT',
      subNFTDesc: '提交您的NFT和藝術品',
      subChain: '提交公鏈',
      subChainDesc: '提交您的區塊鏈',
      bugBounty: '漏洞賞金',
  
      tools: '工具',
  
      build: '開發者中心',
  
      learn: '學習',
  
      explorer: '探索',
  
      company: '公司',
      about: '關於',
      careers: '招聘',
      pressKit: '品牌素材',
      swagShop: '周邊商店',
  
      support: '支持',
      helpCenter: '幫助中心',
      helpCenterDesc: '答疑解惑與獲取資源的首選',
      contactUs: '聯繫我們',
      contactUsDesc: '分享您對TokenPocket的任何建議，提出您的任何疑問',
      forum: '社區論壇',
      forumDesc: '祝您與社區成員會談愉快',
  
      legal: '法律',
      privacyPolicy: '隱私策略',
      terms: '服務協議',
  
      toHome: '返回首頁',
      defiWallet: 'DeFi錢包',
      ETHWallet: 'Ethereum Wallet',
      ethWallet: 'ETH錢包',

      dappStore: 'DApp 商店'
    }
  }
};
